<template>
    <section class="getGrowth">
        <div class='bottom_one dline'>
            <div class='title'>活动规则</div>
            <div>
                <div class='dero'>1、每个分享链接只支持领取1次，赠品领取成功后不支持更换</div>
                <div class='dero'>2、护理套装领取成功后，于3~5个工作日内为您寄出，可在【订单-已完成】查看详情</div>
                <div class='dero'>3、优惠券自领取成功后，3个自然月内有效，可在【优惠券-未使用】查看详情 </div>
            </div>
            <div class='img_content'>
                <img src="/images/growth/chartScan.png" class='img_path'>
            </div>
            
            <div class='scan_tips'>陈真优惠券扫码至专区使用~</div>
        </div>
        <div class='bottom_one'>
            <div class='title'>使用说明</div>
            <div>
                <div class='dero'>*护理套装，是包府独家定制的日常保养良药</div>
                <div class='dero'>【药名】包治百病</div>
                <div class='dero'>【作用】用于清洗护理日常光面皮的保养</div>
                <div class='dero'>【症状】污渍、磨损</div>
                <div class='dero'>【不良效果】有轻微腐蚀性 </div>
                <div class='dero'>【禁忌】LV等配皮植鞣革、苯胺皮不能用 </div>
                <div class='dero'>【使用方法】去污膏和保养油用量切忌直接倒包包上，先少许压送的小毛巾上，打匀毛巾，手感潮潮的即可，切忌湿漉漉的。去污能力很强哦</div>
            </div>
        </div>

        <div class='experience'>
            <div class='experience_title'>
                体验金用途
            </div>

            <img src="/images/growth/one.png" class='img_path'>
            <img src="/images/growth/two.png" class='img_path'>
            <img src="/images/growth/three.png" class='img_path'>
            <img src="/images/growth/four.png" class='img_path'>
            <div class='tips'>
                温馨提示：以上未提及的品类及更加惨烈的损坏情况可以直接一建咨询专属客服，获取最佳建议。
            </div>
        </div>  

        <div class='process'>
            <div class='process_title'>
                工艺介绍与保障
            </div>

            <div class='card'>
                <div class='card_title'>匠人精神</div>
                <div class='card_dero'>互联网+手工艺，颠覆传统手工修护行业，用科技守护工匠之魂，更加高效专注。</div>
                <div class='card_title'>工艺成熟</div>
                <div class='card_dero'>养护案例50万余件，定义176个行业工艺标准，工艺体系成熟完善；成立六年来，持续为行业赋能。团队专业：天津修复中心，北京运营中心，总面积超1万平；300余名工作人员提供全程服务。</div>
                <div class='card_title'>安全保障</div>
                <div class='card_dero'>入库即实现一物一码，全程线上可见，24H监控，贴心安全。</div>
                <div class='card_title'>创业先锋</div>
                <div class='card_dero'>2015年获得创业先锋奖，接受北京电视台专访；2017年获北京市优秀创业项目奖；2018年获得北京市高新技术企业证书。</div>
                <img src="/images/growth/bt1.png" class='img_path img1'>
                <img src="/images/growth/bt2.png" class='img_path img2'>
            </div>

        </div>  
    </section>
</template>

<script>
  export default {
    name: 'growthBottom',
    data () {
      return {
          
      }
    },
    component: {
    
    },
    watch: {},
    computed: {

    },
    created () {
     
    },
    mounted () {

    },
    methods: {
        
    }
  }
</script>

<style lang="scss" scoped>
    .dline{
        border-bottom: 1px solid #DBDBDB;
 
        .img_content{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
        .img_path{
            width: 320px;
            height: 320px;
            margin-top: 60px;
        }
        .scan_tips{
            font-size:28px;
            font-family:PingFangSC-Medium,PingFang SC;
            font-weight:500;
            color:rgba(155,155,155,1);
            text-align: center;
            margin-top: 60px;
        }
    }
    .bottom_one{
        padding:30px;
        padding-bottom:100px;
        .title{
            font-weight: bold;
            color:#000000;
            font-size: 32px;
            margin-top: 28px;
            margin-bottom: 48px;
        }
        .dero{
            font-size:28px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(102,102,102,1);
            line-height:48px;
        }
    }
    .experience{
        background: #0F0F0F;
        padding-top: 90px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .img_path{
            width: 674px;
            margin-top: 60px;
        }
        .tips{
            width:674px;
           
            font-size:26px;
            line-height: 32px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(255,255,255,1);
            margin-top: 70px;
            margin-bottom: 280px;
      
        }
    }
    .experience_title{
        color:#BEE6E6;
        font-size: 40px;
        text-align: center;
        margin-bottom: 40px;
    }

    .process{
        background: #BEE6E6;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-bottom:174px;
        padding-left:40px;
        padding-right:40px;
        .process_title{
            font-weight:bold;
            font-size: 32px;
            color:#000;
            text-align: center;
            padding-top: 120px;
            margin-bottom: 50px;

        }
        .card{
            background: #fff;
    
            background:rgba(255,255,255,1);
            border-radius:10px;
            padding-top:50px;
            padding-left: 32px;
            padding-right:32px;
            
            .card_title{
            
                font-size:32px;
                font-family:PingFang-SC-Bold,PingFang-SC;
                font-weight:bold;
                color:rgba(0,0,0,1);
                line-height:44px;
                text-align: center;
                margin-top: 60px;
            }
            .img_path{
                display: block;
                width: 626px;
                margin-top: 40px;
            }
            .card_dero{
              
                font-size:28px;
                font-family:PingFangSC-Regular,PingFang SC;
                font-weight:400;
                color:rgba(102,102,102,1);
                line-height:48px;
                margin-top:30px;
            }
            .img1{
                margin-top: 100px;
            }
            .img2{
                margin-bottom: 76px;
            }
        }
    }

</style>
